import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import 'vue-select/dist/vue-select.css';
import VueAnalytics from 'vue-analytics';
import VModal from 'vue-js-modal'
import Notifications from 'vue-notification'

import "@/design/index.scss";

import store from '@/state/store'

import App from './App.vue'

import tinymce from 'vue-tinymce-editor'

import VueCountdownTimer from 'vuejs-countdown-timer';

import './filters/BaseFilter';
import './filters/NfseFilter';


Vue.component('tinymce', tinymce)


Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(VueSweetalert2);
Vue.use(VModal)
Vue.use(Notifications)
Vue.use(Toast, {
    transition: "Vue-Toastification__fade",
    maxToasts: 20,
    newestOnTop: true,
    position: "bottom-right"
});

Vue.use(VueCountdownTimer);
// Configuration VueAnalytics
Vue.use(VueAnalytics, {
    id: 'UA-64890101-3',
    router
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
